import { CheckIcon, XIcon } from 'lucide-react'

import { cn } from '@/utils'

interface SceneBadgeProps {
  kind: 'accepted' | 'refused'
  className?: string
}

export const SceneBadge = ({ kind, className }: SceneBadgeProps) => {
  const Icon = kind === 'accepted' ? CheckIcon : XIcon
  return (
    <span
      className={cn(
        'flex size-6 items-center justify-center rounded-full text-white shadow-md ring-2 ring-white',
        kind === 'accepted' ? 'bg-brand' : 'bg-blue-5',
        className,
      )}
    >
      <Icon aria-hidden strokeWidth={3} className="size-3.5" />
    </span>
  )
}
